export default (theme) => ({
    root: {
        padding: 20,
        [`${theme.breakpoints.up('md')}`]: {
            width: 700,
        },
    },
});
